(function ($) {
    $(document).ready(function () {
        var slider = $('.entry__slider');

        if (slider.length) {

            slider.imagesLoaded().done(function () {

                slider.on('init', () => {                        
                    $('.bottom__slider').each(function(){
                        var toppos;
                        var slideWidth;
                        $(this).find('.slick-slide img').load(function(){
                            toppos = $(this).height()/2;
                            $(this).parents().eq(4).find('.slick-arrow').css('top',toppos+'px');
                            
                            slideWidth = $(this).width();
                            $(this).parents().eq(1).find('.entry__slider__caption').css('width', slideWidth);
                        });
                    });
                });

                slider.slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    lazyLoad: 'ondemand',
                    arrows:true,
                    infinite: true,
                    centerMode: true,
                    autoplaySpeed: 5000,
                    variableWidth: true,
                    centerPadding: '0px',
                    dots: false,
                    prevArrow: '<button type="button" class="entry__slider__arrow entry__slider__arrow-left"><div class="entry__slider__arrowImg-left"> </div></button>',
                    nextArrow: '<button type="button" class="entry__slider__arrow entry__slider__arrow-right"><div class="entry__slider__arrowImg-right"> </div></button>',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: true,
                                centerPadding:'0px',
                                slidesToShow: 1,
                            }
                        },
                    ],
                })
            });
        }
    });
})(jQuery);